import React, { ErrorInfo, Fragment, Suspense } from "react";
import ReactDOM from "react-dom/client";

import App from "./App";

import * as serviceWorker from "serviceWorkerRegistration";
import { BrowserRouter as Router } from "react-router-dom";
// import RoutingAnalitycsGA from "./components/RoutingAnalitycsGA";
import { CssVariables, CssStyles } from "./assets/customAssets";

import { Provider } from "react-redux";
import { dataFormStore } from "core/redux/store/store";
import { ErrorBoundary } from "react-error-boundary";

import "./styles/index.css";
import "./styles/variables.css";
import "./styles/AntOverload.css";
import LoggingRepository from "core/data/LoggingRepository";
import FallbackComponent from "components/FallBackComponent/FallBackComponent";
import { ILoggingRequest, SeverityEnum } from "core/interfaces/data/ILoggingRequest";
import i18n from "utils/i18n";
import { StorageHelper } from "utils/SessionStorageHelper";
import LoadingScheleton from "components/LoadingScheleton/LoadingScheleton";
import axe from "@axe-core/react";


if (process.env.NODE_ENV !== "production") {
	axe(React, ReactDOM, 1000);
}

const getAppComponent = () => {
	return (
		<>
			<link rel="stylesheet" href={CssVariables} type="text/css" />
			<React.StrictMode>
				{/**
				 * Questo React.Suspense serve per i18n per caricare le lingue, mentre carica di mostrare un caricamento
				 */}
				<ErrorBoundary
					FallbackComponent={FallbackComponent}
					onError={(error: Error, errorInfo: ErrorInfo) => {
						var err: ILoggingRequest = {
							Message: error.message + " - " + errorInfo.componentStack,
							Severity: SeverityEnum.LogError,
							culture: i18n.language,
						};
						LoggingRepository.Log(err);
						console.log(err);
					}}
					onReset={() => {
						StorageHelper.setItem("PAGE_ERROR_OCCURRED", JSON.stringify(true));
						//	alert("gestire il reset dello state!");
						// reset the state of your app
					}}
				>
					<Suspense fallback={<LoadingScheleton active />}>
						
						<Router basename={`${process.env.PUBLIC_URL}`}>
							{/* <RoutingAnalitycsGA trackerID={window.CONFIG.REACT_APP_GA_TRACKING}> */}
							<Provider store={dataFormStore}>


								<App />


							</Provider>
							{/* </RoutingAnalitycsGA> */}
						</Router>
					</Suspense>
				</ErrorBoundary>
			</React.StrictMode >
			{/* lasciare qui per sovrascrivere gli stili "standard" */}
			< link rel="stylesheet" href={CssStyles} type="text/css" />
		</>
	);
};

const root = ReactDOM.createRoot(document.getElementById("root") as Element)
root.render(getAppComponent())

serviceWorker.register();
